export const removeDuplicates = (arr) => {
    const result = [];
    const duplicatesIndices = [];

    // Loop through each item in the original array
    arr.forEach((current, index) => {
        if (duplicatesIndices.includes(index)) return;

        result.push(current);

        // Loop through each other item on array after the current one
        for (
            let comparisonIndex = index + 1;
            comparisonIndex < arr.length;
            comparisonIndex++
        ) {
            const comparison = arr[comparisonIndex];
            const currentKeys = Object.keys(current);
            const comparisonKeys = Object.keys(comparison);

            // Check number of keys in objects
            if (currentKeys.length !== comparisonKeys.length) continue;

            // Check key names
            const currentKeysString = currentKeys.sort().join('').toLowerCase();
            const comparisonKeysString = comparisonKeys
                .sort()
                .join('')
                .toLowerCase();
            if (currentKeysString !== comparisonKeysString) continue;

            // Check values
            let valuesEqual = true;
            for (let i = 0; i < currentKeys.length; i++) {
                const key = currentKeys[i];
                if (current[key] !== comparison[key]) {
                    valuesEqual = false;
                    break;
                }
            }
            if (valuesEqual) duplicatesIndices.push(comparisonIndex);
        }
    });

    return result;
};

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getStorybookDefaults(componentName, defaultStyles) {
    return Object.keys(defaultStyles).reduce(function (result, key) {
        result[componentName + capitalizeFirstLetter(key)] = defaultStyles[key];
        return result;
    }, {});
}
